import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder_key';

// Genel, kimliksiz Supabase client (public okuma gerektiren nadir durumlar için)
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Clerk JWT'siyle kimlikli bir Supabase client oluşturur — RLS policy'leri
// auth.jwt() ->> 'sub' üzerinden bu token'ı okur (ana repodaki desenle birebir aynı).
export const createClerkSupabaseClient = (clerkToken: string) => {
  return createClient(supabaseUrl, supabaseAnonKey, {
    global: {
      headers: {
        Authorization: `Bearer ${clerkToken}`,
      },
    },
  });
};
